import { useEffect, useState } from 'react'
import { getKitPreferences } from '../api/account'
import { useAuth } from '../context/AuthContext'

/**
 * Preferencje doboru zalogowanego konta (`GET /kit-preferences`), wczytane raz na sesję strony i wspólne dla
 * wszystkich wyborów modelu w Projekcie 3D. Gość dostaje null (bez zapytania). Po zmianie preferencji w ustawieniach
 * nowe wartości przyjdą po odświeżeniu strony.
 */

let pamiec = null // { userKey, obietnica, dane }

const usePreferencjeDoboru = () => {
  const { isAuthenticated, user } = useAuth()
  const klucz = isAuthenticated ? String(user?.id ?? user?.email ?? 'konto') : null
  const [dane, setDane] = useState(() => (klucz && pamiec?.userKey === klucz ? pamiec.dane : null))

  useEffect(() => {
    if (!klucz) { setDane(null); return undefined }
    let aktualne = true
    if (!pamiec || pamiec.userKey !== klucz) {
      pamiec = { userKey: klucz, dane: null, obietnica: getKitPreferences().then((res) => (res.ok ? res.data : null)).catch(() => null) }
    }
    pamiec.obietnica.then((d) => {
      if (pamiec?.userKey === klucz) pamiec.dane = d
      if (aktualne) setDane(d)
    })
    return () => { aktualne = false }
  }, [klucz])

  return dane
}

export default usePreferencjeDoboru
